export default {"src":"/_next/static/media/BERY.34458068.svg","height":18,"width":18};